module.exports = __webpack_public_path__ + "static/fonts/Gilroy-Heavy.a992bf64.otf";